import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'

type Display = 'block' | 'inline'

interface Props {
  url: string
  newTab?: boolean
  display?: Display
  className?: string
}

const useStyles = createUseStyles({
  a: {
    display: (display: { display?: Display }) => display,
    textDecoration: 'none',
  },
})

export const Link: FC<Props> = flowMax(
  addDisplayName('Link'),
  addProps(({ display }) => ({
    classes: useStyles({ display }),
  })),
  addProps(({ newTab }) => ({
    target: newTab ? '_blank' : undefined,
  })),
  ({ url, target, classes, className, children }) => (
    <a href={url} target={target} className={cx(classes.a, className)}>
      {children}
    </a>
  )
)
